import * as React from 'react';
import Button from '@telia-front/button';
import Grid, { GridColumn } from '@telia-front/grid';
import Heading from '@telia-front/heading';
import Icon from '@telia-front/icon';
import Separator from '@telia-front/separator';
import { TableCell, TableRow } from '@telia-front/table';
import { TableCollapse, TableCollapseTrigger } from '@telia-front/table-collapse';
import { TvComparisonContext } from './index';
import ChannelPriceTableCell from './channel-price-table-cell';
import MobileTableHeader from './mobile-table-header';
const MobileThemePackets = (props) => {
    const { themePackets, packets, initialHeadingLevel = 2 } = props;
    const { showMoreLabel, showLessLabel } = React.useContext(TvComparisonContext);
    const renderThemePacketRow = (packet) => {
        return (React.createElement(React.Fragment, { key: packet.id },
            React.createElement(TableRow, { background: "neutral-1", className: "tv-comparison__row" },
                React.createElement(TableCell, { colSpan: 3, className: "tv-comparison__name-cell" },
                    React.createElement(Grid, { noWrap: true, align: ['middle-xs'] },
                        React.createElement(GridColumn, { width: ['min'] },
                            React.createElement(Icon, { size: "md", modifiers: packet.icon, className: "visible" })),
                        React.createElement(GridColumn, { width: ['max'] },
                            React.createElement("p", { className: "h5 text-bold" }, packet.title)),
                        React.createElement(GridColumn, { width: ['min'] }, showMoreLabel && (React.createElement(TableCollapseTrigger, { text: showMoreLabel, activeText: showLessLabel, url: `#${packet.id}`, iconRight: "#arrow-down", link: true })))))),
            React.createElement(TableRow, { id: packet.id, collapsible: true, background: "neutral-1", className: "tv-comparison__row" },
                React.createElement(TableCell, { colSpan: 3, className: "text tv-comparison__info-cell" },
                    packet.description && React.createElement("div", null, packet.description),
                    packet.channels && packet.description && React.createElement(Separator, { spacing: "xsmall", weight: "thin" }),
                    packet.channels && (React.createElement("p", null, packet.channels
                        .map(p => {
                        return p.title;
                    })
                        .join(', '))))),
            React.createElement(TableRow, { background: "neutral-1", className: "tv-comparison__row tv-comparison__price-row" }, packet.packetPrices.map((price, index) => (React.createElement(ChannelPriceTableCell, { price: price, width: 4, key: index, variant: "secondary", alignCenter: true }))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading, { level: initialHeadingLevel, className: "h4 tv-comparison__header" },
            themePackets.label,
            themePackets.count && (React.createElement(React.Fragment, null,
                " ",
                React.createElement("span", { className: "text-light" },
                    "(",
                    themePackets.count,
                    ")")))),
        React.createElement(TableCollapse, { className: "tv-comparison__table", bordered: true },
            React.createElement("thead", { className: "sr-only" },
                React.createElement(MobileTableHeader, { packets: packets })),
            React.createElement("tbody", null, themePackets.packets.map(renderThemePacketRow))),
        themePackets.viewAllButton && (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            React.createElement("p", { className: "text-center" },
                React.createElement(Button, Object.assign({}, themePackets.viewAllButton)))))));
};
export default MobileThemePackets;
